<span style="white-space: nowrap; display: flex" [class.isActive]="CanMakecalls()" (click)="Call()"> <i style="flex-grow: 1">+{{phonenumber()}}</i> <i *ngIf="CanMakecalls()" class="fa-solid fa-phone"></i></span>
